import API from "utils/API";
import { useState } from "react";
import { useForm } from "react-hook-form";

export type ContactUsInputs = {
  email: string;
  tellUs: string;
  lastName: string;
  firstName: string;
  phoneNumber: string;
  message: string;
};

const useContactus = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [showDialogConfirm, setShowDialogConfirm] = useState(false);

  const form = useForm<ContactUsInputs>({
    defaultValues: {
      tellUs: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      message: "",
    },
  });

  const onSubmit = form.handleSubmit(async (data) => {
    setLoading(true);
    try {
      const response = await API.post({
        url: `/send-contact`,
        data: {
          email: data.email?.trim(),
          firstName: data.firstName,
          lastName: data.lastName,
          phoneNumber: data.phoneNumber.replace(/ /g, ""),
          typeOfUser: data.tellUs,
          message: data.message,
        },
      });
      if (!("error" in response)) {
        form.reset();
        setShowDialogConfirm(true);
      }
    } catch (unknownError) {
      setErrorMessage(String(unknownError));
      console.error(unknownError);
    }

    setLoading(false);
  });

  return {
    onSubmit,
    errorMessage,
    setErrorMessage,
    showDialogConfirm,
    setShowDialogConfirm,
    loading,
    ...form,
  };
};

export default useContactus;
